import React from 'react';
export function SalesLetterSection() {
  const reasons = [{
    num: '01',
    title: 'Profundidad',
    subtitle: '100+ preguntas que te guían solas',
    desc: 'Preguntas terapéuticas diseñadas para llevarte al origen exacto de lo que sentís — sin necesitar un profesional al lado.'
  }, {
    num: '02',
    title: 'Practicidad',
    subtitle: 'Herramientas para el momento exacto',
    desc: 'Funcionan cuando explotás, cuando comés por ansiedad, cuando sentís que perdés el control. No después — en el momento.'
  }, {
    num: '03',
    title: 'Completitud',
    subtitle: '3 sistemas · Mente + conducta + cuerpo',
    desc: 'El único enfoque que integra las tres dimensiones donde viven las emociones. El cambio es real y duradero.'
  }];
  return <section className="w-full px-4 py-6 md:py-10" data-id="element-128">
      <div className="max-w-3xl mx-auto space-y-5" data-id="element-129">
        <div className="text-center space-y-2" data-id="element-130">
          <span className="text-primary font-bold tracking-wider uppercase text-xs" data-id="element-131">
            El sistema completo
          </span>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-text-main" data-id="element-132">
            ¿Por qué funciona cuando todo lo demás falló?
          </h2>
        </div>

        <div className="space-y-3" data-id="element-133">
          {reasons.map((reason, index) => <div key={index} className="bg-white p-4 md:p-5 rounded-xl shadow-sm border border-gray-100 flex gap-3 items-start" data-id="element-134">
              <div className="text-2xl font-serif font-bold text-pink-600 leading-none mt-0.5" data-id="element-135">
                {reason.num}
              </div>
              <div className="space-y-1" data-id="element-136">
                <h4 className="text-base font-bold text-text-main" data-id="element-137">
                  {reason.title} —{' '}
                  <span className="text-primary" data-id="element-138">{reason.subtitle}</span>
                </h4>
                <p className="text-text-muted text-sm leading-snug" data-id="element-139">
                  {reason.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}